export const getAddBooksData = (institutionCode) => {
	switch (institutionCode) {
		case 'MIAMINSTITUTE':
			return [...allBooks, ...data_MIAMINSTITUTE];
		case 'LAURELI':
			return [...allBooks, ...data_LAURELI];
		case 'CMVC':
		case 'AMHEALTH':
		case 'MIAMI_BROWARD':
		case 'HCAS':
		case 'ADTC':
		case 'PCI':
			return [...allBooks, ...DENTISTRY_BOOKS];
		default:
			return allBooks;
	}
};

const allBooks = [
	{
		title: 'Air Source Heat Pump Buying Guide',
		authors: ['Northeast Energy Efficiency Partnerships'],
		abstract:
			'This guide is divided into two main sections. Part 1 describes what a heat pump is, how it works, what types are available, and how to think about choosing one for your home. It also includes general information about heating and cooling costs, and dispels some old myths about heat pumps that don’t apply to today’s high-efficiency models. Once you’ve decided you want to move forward with a heat pump, Part 2 introduces a series of steps to help you organize the process and offers a checklist of questions to ask potential installers. There is more specific guidance on what to look for during the design and installation process, based on the type of system you’re installing and how it fits into your house.',
		publication_date: '2020',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/2.+ASHP_buyingguide_5.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Energy',
			'heat pump',
			'air source heat pump',
			'ASHP',
			'heat pump buying guide',
			'ductless heat pump',
			'mini split',
			'mini-split',
			'split system',
			'heating and cooling',
			'home heating',
			'cooling costs',
			'heating costs',
			'efficiency',
			'high efficiency heat pump',
			'seer',
			'hspf',
			'cop',
			'cold climate heat pump',
			'installer checklist',
			'choose an installer',
			'design and installation',
			'best practices',
			'heat pump myths',
			'retrofit',
			'commissioning',
		],
	},
	{
		title:
			'Assessment of Residential and Small Commercial Air-Source Heat pump (ASHP) Installation Practices in Cold-Climates',
		authors: ['Northeast Energy Efficiency Partnerships'],
		abstract:
			'The following assessment report includes four sections highlighting current practices and guidance: Contractor practices for data collection prior to heat pump selection; Contractor practices for sizing/selecting ASHPs in cold climates; Contractor practices for installing ASHPs in cold climates; and Guidance resources related to sizing, selecting and installing ASHPs in cold climates.',
		publication_date: '2017',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/3.+AssessmentofResandSmallCommASHPInstallationPracticesinCold-Climates.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Energy',
			'heat pump',
			'air source heat pump',
			'ASHP',
			'cold climate',
			'cold-climate heat pump',
			'installation practices',
			'contractor practices',
			'residential',
			'small commercial',
			'heat pump sizing',
			'sizing and selecting',
			'equipment selection',
			'load calculation',
			'manual j',
			'design temperature',
			'commissioning',
			'installation quality',
			'best practice installation',
			'data collection',
			'field assessment',
			'performance verification',
			'airflow',
			'refrigerant charge',
		],
	},
	{
		title: 'Basic HVAC',
		authors: ['Aaron Lee'],
		abstract:
			'Contents: Part I. Electrical Terms and Definitions, Part II. Heating, Part III. Ventilation, Part IV. Mechanical Cooling.',
		publication_date: '2021',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/4.+Lee+-+2021+-+Basic+HVAC.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Energy',
			'basic hvac',
			'hvac fundamentals',
			'heating',
			'ventilation',
			'mechanical cooling',
			'air conditioning',
			'refrigeration cycle',
			'compressor',
			'condenser',
			'evaporator',
			'thermostat',
			'controls',
			'electrical terms',
			'electrical basics',
			'ac power',
			'voltage',
			'current',
			'resistance',
			'hvac terminology',
			'maintenance basics',
			'safety',
			'troubleshooting',
			'ductwork',
			'airflow',
		],
	},
	{
		title: 'Can renewable energy sources power the world?',
		authors: ['The Open University'],
		abstract:
			'We ask the question ‘Can renewable energy sources power the world?’ as a response to the growing awareness that increased use of renewable energy technologies is making a major contribution to global efforts to limit anthropogenic climate change. The course begins by examining the environmental concerns that have caused a rise in interest in renewable energy, introducing the main sources and technologies, and describing global efforts to increase the share of renewables. The course then looks at each of the principal renewable energy technologies and the contributions they might make to global energy demand. Finally, several future energy scenarios are analysed to show how combinations of renewable energy sources and technologies could provide a major share of global energy needs.',
		publication_date: '2018',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/5.+Can+renewable+energy+sources+power+the+world.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'Energy',
			'renewable energy',
			'can renewables power the world',
			'global energy demand',
			'energy transition',
			'decarbonization',
			'climate change',
			'clean energy',
			'solar power',
			'wind power',
			'hydroelectric',
			'geothermal energy',
			'bioenergy',
			'biomass',
			'energy scenarios',
			'future energy',
			'energy mix',
			'grid integration',
			'renewable technologies',
			'carbon emissions',
			'mitigation',
			'sustainability',
		],
	},
	{
		title: 'Climate change and renewable energy',
		authors: ['The Open University'],
		abstract:
			'This free course, Climate Change and Renewable Energy, describes the basic science of the greenhouse effect and how it has been modified by human activities such as the burning of fossil fuels. It describes the large cuts in greenhouse gas emissions that will be required to stabilise the global climate, the role of international climate change negotiations and the need for an energy transition away from fossil fuels to renewable energy sources.',
		publication_date: '2024',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/6.+Climate+change+and+renewable+energy.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'Energy',
			'climate change',
			'renewable energy',
			'greenhouse effect',
			'greenhouse gases',
			'ghg emissions',
			'carbon emissions',
			'fossil fuels',
			'global warming',
			'climate science',
			'mitigation',
			'energy transition',
			'decarbonization',
			'net zero',
			'climate policy',
			'international negotiations',
			'paris agreement',
			'renewables',
			'solar',
			'wind',
			'low carbon energy',
		],
	},
	{
		title: "Electrician's Math and Basic Electrical Formulas",
		authors: ['Mike Holt'],
		abstract:
			'This free PDF is extracted from Mike Holt’s Illustrated Guide to Understanding Electrical Theory. In order to construct a building that will last into the future, a strong foundation is a prerequisite. Math and basic electrical concepts are very similar to the foundation of a building.',
		publication_date: '2023',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/7.+MikeHoltBasicMath.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'Mathematics',
			'Electrical engineering',
			'electrician math',
			'electrical math',
			'electrical formulas',
			'basic electrical theory',
			'ohms law',
			'voltage',
			'current',
			'amperage',
			'resistance',
			'watts',
			'kilowatts',
			'power',
			'power factor',
			'ac circuits',
			'dc circuits',
			'series circuits',
			'parallel circuits',
			'conduit fill',
			'wire sizing',
			'nec calculations',
			'load calculations',
		],
	},
	{
		title: 'Emerging Heat Pump Technologies',
		authors: ['Northeast Energy Efficiency Partnerships'],
		abstract:
			'This brief discusses air source heat pump technologies that are up-and-coming in functionality and availability for applications in the Northeast and Mid-Atlantic region. The emerging heat pump technology categories are listed in Table 1 and provide detailed information about the existing status of the technology as well as advantages, challenges, and technology examples. Under each category, the “applications” section mentions which building type or situation may most readily benefit from that technology.',
		publication_date: '2024',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/8.+Emerging+Heat+Pump+Technologies.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Energy',
			'emerging heat pump technologies',
			'heat pump technology',
			'air source heat pump',
			'ASHP',
			'cold climate heat pump',
			'inverter heat pump',
			'variable speed compressor',
			'variable refrigerant flow',
			'VRF',
			'low gwp refrigerants',
			'refrigerants',
			'R32',
			'R290',
			'heat pump water heater',
			'air-to-water heat pump',
			'packaged terminal heat pump',
			'PTAC',
			'commercial applications',
			'residential applications',
			'building electrification',
			'decarbonization',
			'northeast',
			'mid-atlantic',
		],
	},
	{
		title: 'Energy in buildings',
		authors: ['The Open University'],
		abstract:
			'Themes covered in this free course, Energy in buildings, include reducing heating demand in buildings, heating systems and fuel emissions, and reducing electricity use by appliances.',
		publication_date: '2024',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/9.+Energy+in+buildings.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Energy',
			'energy in buildings',
			'building energy efficiency',
			'heating demand',
			'heat loss',
			'insulation',
			'building envelope',
			'retrofit',
			'weatherization',
			'heating systems',
			'fuel emissions',
			'carbon emissions',
			'decarbonization',
			'electricity use',
			'appliances',
			'energy consumption',
			'energy saving',
			'low energy buildings',
			'building services',
			'energy audit',
		],
	},
	{
		title: 'Engineering: The challenge of temperature',
		authors: ['The Open University'],
		abstract:
			'Temperature: understand the main ways in which a house loses heat energy, carry out basic U-value calculations for windows and insulation materials, understand the factors influencing heating system efficiency, carry out basic calculations concerning the efficiencies and CO2 emissions of different heating systems, carry out basic calculations concerning lighting.',
		publication_date: '2024',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/10.+Engineering+The+challenge+of+temperature.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Refrigeration',
			'temperature',
			'thermal engineering',
			'heat transfer',
			'heat loss',
			'building heat loss',
			'u-value',
			'r-value',
			'windows',
			'insulation materials',
			'thermal insulation',
			'heating efficiency',
			'boiler efficiency',
			'heat pump efficiency',
			'co2 emissions',
			'carbon emissions',
			'lighting efficiency',
			'energy calculations',
			'engineering calculations',
			'home energy',
		],
	},
	{
		title: 'Good practice guide Heat pump installation - March 2022',
		authors: ['Energy Efficiency and Conservation Authority'],
		abstract:
			'This guide provides good practice guidelines for designing and installing the most common type of residential heat pump system – air-to-air single-split heat pump systems (also known as reverse-cycle air conditioners), used primarily for heating. The guide is aimed at experienced installers of heat pumps, and it gives the process to follow for system design and installation into both new and existing homes.',
		publication_date: '2022',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/11.+0468+EEC+Heat+Pump+Install+Guide_DEC2021_3_MM.indd.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Refrigeration',
			'heat pump installation',
			'heat pump installer guide',
			'good practice guide',
			'air-to-air heat pump',
			'single split',
			'split system',
			'reverse cycle air conditioner',
			'design and install',
			'install process',
			'commissioning',
			'airflow setup',
			'refrigerant handling',
			'vacuum pump',
			'leak testing',
			'pipe sizing',
			'indoor unit placement',
			'outdoor unit placement',
			'noise considerations',
			'new homes',
			'existing homes',
		],
	},
	{
		title: 'HVAC/PLUMBING',
		authors: [
			'U.S. Department of Housing and Urban Development Office of Policy Development and Research',
		],
		abstract:
			'The content for this guidebook, HVAC/Plumbing, has been gathered from professionals in the housing rehabilitation field; manufacturers and suppliers of innovative technologies, materials, components, tools, and equipment; trade shows, conferences, reports, and publications considering such issues; trade organizations; and building research centers.',
		publication_date: '1999',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/12.+hvac-Plum.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Plumbing',
			'housing rehabilitation',
			'building rehab',
			'building systems',
			'hvac plumbing guide',
			'mechanical systems',
			'piping',
			'pipe fittings',
			'fixtures',
			'drainage',
			'water supply',
			'domestic hot water',
			'boilers',
			'furnaces',
			'ventilation',
			'air conditioning',
			'tools and equipment',
			'materials and components',
			'codes and standards',
			'trade organizations',
			'construction technology',
		],
	},
	{
		title: 'HVAC Systems Design Handbook',
		authors: ['McGraw-Hill'],
		abstract:
			'A first-hand knowledge of engineering fundamentals is a must for HVAC designers. All problems are helped toward solution by an ability to think clearly, to move from problem definition to identification of alternatives, to evaluation of alternatives, to selection and implementation of preferred action. Knowledge of political constraints (codes and regulations) as well as technical and ethical factors is an important part of the designer’s tool kit. Knowledge of fundamental engineering physics in fluid mechanics, thermodynamics, heat transfer, psychrometrics, and sound control is absolutely essential to the HVAC designer. Energy conservation in system design has become a moral imperative. An understanding of these fundamentals will make all other issues treated in this book easier to understand.',
		publication_date: '2004',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/13.+HVAC4th.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Refrigeration',
			'hvac design',
			'hvac systems design',
			'hvac handbook',
			'engineering fundamentals',
			'fluid mechanics',
			'thermodynamics',
			'heat transfer',
			'psychrometrics',
			'psychrometric chart',
			'duct design',
			'air distribution',
			'load calculations',
			'heating load',
			'cooling load',
			'energy conservation',
			'energy efficiency',
			'codes and regulations',
			'sound control',
			'acoustics',
			'building services engineering',
			'controls',
			'commissioning',
		],
	},
	{
		title: 'Heat Pumps - Operation and Maintenance Guide',
		authors: ['SEAI'],
		abstract:
			'This guide is provided as part of a suite of three heat pump guides: an Implementation Guide, a Technology Guide, and an Operation & Maintenance Guide, which collectively aim at providing an understanding of heat pump technology, its implementation and operational management.',
		publication_date: '2020',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/14.Heat-Pump-Operation-and-Maintenance-Guide.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Trades', 'HVAC', 'Refrigeration'],
	},
	{
		title:
			'5 Myths and Truths about Massage Therapy: Letting Go Without Losing Heart',
		authors: ['Tracy Walton'],
		abstract:
			'This book contains the effects of massage on: Endorphins, Immunity, Cortisol, Blood circulation and “Toxins” and toxin release.',
		publication_date: '2016',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/15.5-Myths-and-Truths-about-Massage-Therapy_final.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Massage', 'Therapy'],
	},
	{
		title: 'Application of Plant-Based Molecules and Materials in Cosmetics',
		authors: ['Paulraj Mosae Mosae Selvakumar'],
		abstract:
			'With the growing demand for products that are gentle on the skin and manufactured by eco-friendly means, the field of cosmetics is witnessing a remarkable shift toward natural ingredients [...]',
		publication_date: '2024',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/16.cosmetics-11-00211.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Cosmetics', 'Plant Based Products'],
	},
	{
		title: 'BAM Chapter 23: Methods for Cosmetics',
		authors: ['FDA : Human Foods Program'],
		abstract:
			"FDA's Bacteriological Analytical Manual (BAM) presents the agency's preferred laboratory procedures for microbiological analyses of foods and cosmetics.",
		publication_date: '2025',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/17.BAM-Ch23-MethodsForCosmetics-070324.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Cosmetics', 'Skincare'],
	},
	{
		title: 'Barbering Techniques for Hairstylists',
		authors: ['Arden Magtiza', 'Gary Franceschini'],
		abstract:
			'This manual serves as a guide for apprentices who desire to grow beyond their foundational haircutting knowledge and skills, and expand their knowledge to include more advanced barbering services, such as beard and moustache design, and straight razor shaves.',
		publication_date: '2021',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/18.Barbering-Techniques-for-Hairstylists-1725562557.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Barbering Techniques', 'Hair'],
	},
	{
		title: 'Cosmetics Labeling Guide',
		authors: ['FDA: Office of the Commissioner'],
		abstract: 'FDA guide to labeling cosmetic products.',
		publication_date: '2024',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/19.Cosmetics-Labeling-Guide.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Cosmetics', 'Skincare'],
	},
	{
		title: 'Evidence-Based Massage Therapy: A Guide for Clinical Practice',
		authors: ['Richard Lebert'],
		abstract:
			'This clinical practice handbook will prove essential to massage therapists, physical therapists, chiropractors, medical doctors, psychologists and other health professionals who care for people with musculoskeletal pain. It is a living document and will be continuously updated as new research becomes available.',
		publication_date: '2018',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/20.Evidence_Based_Massage_Therapy_1592410090_0232c34992.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Massage', 'Therapy'],
	},
	{
		title: 'Hair Colour for Hairstylists: Level 2',
		authors: ['Arden Magtiza'],
		abstract:
			'This manual serves as a guide for apprentices with the desire to stretch beyond their foundational colour knowledge and skills so as to reach a higher level of competency. This text will walk the stylist step-by-step through many current and advanced techniques used in the industry today.',
		publication_date: '2021',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/21.Hair-Colour-for-Hairstylists-Level-2-1666366761.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Hairstyle Techniques', 'Hair'],
	},
	{
		title: 'Introductory Chemistry - 1st Canadian Edition',
		authors: ['Jessie A Key', 'David W. Ball'],
		abstract:
			'The goal of this textbook is not to make you an expert. True expertise in any field is a years-long endeavor. Here I will survey some of the basic topics of chemistry. This survey should give you enough knowledge to appreciate the impact of chemistry in everyday life and, if necessary, prepare you for additional instruction in chemistry.',
		publication_date: '2014',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/22.Introductory-Chemistry-1st-Canadian-Edition-1695676100.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Chemistry', 'Surveys'],
	},
	{
		title:
			'The Case for Pain Relief: 5 Research Studies for Massage Therapists',
		authors: ['Massage Theraphy Foundation'],
		abstract:
			'Contents: ‣ Acupressure and chronic neck pain ‣ Massage therapy and hand pain ‣ Thai massage and pain relief ‣ Massage therapy and low back pain ‣ Myofascial release and fibromyalgia',
		publication_date: '2012',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/23.mtf-pain-relief-ebook.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Massage', 'Therapy'],
	},
	{
		title: 'Climate Risk Toolbox',
		authors: ['Food and Agriculture Organization of the United Nations - FAO'],
		abstract:
			'The Climate Risk Toolbox (CRTB) is an open-access resource, hosted on the Hand-in-Hand geospatial platform, a digital public platform that supports users with analyzing and comparing data on climate risks on food and agriculture, to enhance adaptation interventions worldwide (FAO, 2025a, FAO, 2025b).',
		publication_date: '2025',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/27.cd4543en.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Biology', 'Climate Risk', 'Climate'],
	},
	{
		title: 'Green Cities Challenge Badge',
		authors: ['Food and Agriculture Organization of the United Nations - FAO'],
		abstract:
			'This booklet is intended as a guide for teachers and youth leaders. These individuals are responsible for the development of programmes and activities that are suitable for their group and for ensuring the required supervision and safety provisions so that all participants are safe and sound.',
		publication_date: '2025',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/28.cd6459en.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Biology', 'Climate Risk', 'Climate'],
	},
	{
		title:
			'Infection Prevention and Control in Primary Care: A Toolbox of Resources',
		authors: ['World Health Organization'],
		abstract:
			'The recently published World Health Organization (WHO) Strengthening infection prevention and control in primary care1 document collates existing standards, measurement and implementation approaches, and resources for infection prevention and control (IPC) in primary care. During its development, it became apparent that a number of already existing tools and resources have the potential to support facility-level implementation of IPC in primary care.',
		publication_date: '2021',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/30.9789240035249-eng.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Health Sciences', 'Infections', 'Public Health', 'Toolkit'],
	},
	{
		title: 'Mentorship model for veterinary paraprofessionals',
		authors: ['Food and Agriculture Organization of the United Nations - FAO'],
		abstract:
			'This book contains the experience of the training “Growing your business through preventive livestock health care”. Recruiting and attracting mentors through networking and professional development opportunities was successful and many VPPs had positive experiences and the potential for new long-term professional connections.',
		publication_date: '2025',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/31.cd3615en.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Biology', 'Veterinary education', 'Agricultural education'],
	},
	{
		title: 'Business Writing for Everyone',
		authors: ['Arley Cruthers'],
		abstract:
			'Business Writing For Everyone is an inclusive guide to writing in the workplace. The book takes a process-oriented, storytelling approach to composition: focusing less on genre and more on the decisions that effective business communicators make. Business Writing For Everyone also contains interactive H5P activities for students to test their learning, and activities for further reflection that instructors can use in the classroom or assign as homework.',
		publication_date: '2019',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/33.Business-Writing-For-Everyone-1637897846.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Business management', 'Communication skills', 'Writing'],
	},
	{
		title: 'Business/Technical Mathematics',
		authors: ['Izabela Mazur', 'Kim Moshenko'],
		abstract:
			'The content of this textbook is aligned with the British Columbia Adult Basic Education learning outcomes for the Advanced Level Business/Technical Mathematics. The textbook covers nine groups of learning outcomes organized in chapters. The first three chapters cover the core learning outcomes: Operations with Real Numbers; First Degree Equations and Inequalities; Equations and their Graphs. The remaining chapters cover: Systems of Equations; Trigonometry; Health Option; Finance; Data Analysis 1; Data Analysis 2.',
		publication_date: '2021',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/34.BusinessTechnical-Mathematics-1742928169.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Business management', 'Mathematics education'],
	},
	{
		title: 'Communication for Business Professionals',
		authors: ['Ontario Business Faculty', 'eCampusOntario Program Managers'],
		abstract:
			'This book provides a comprehensive, integrated approach to the study and application of written and oral business communication to serve both students and instructors. The text includes features such as learning objectives, exercises, real-world examples, key terms, and post-chapter assessments.',
		publication_date: '2018',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/35.Communication-for-Business-Professionals-1564507599.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Business management', 'Communication skills', 'Writing'],
	},
	{
		title: 'Contemporary Issues in Strategic Marketing',
		authors: ['Ahmet Kemal Sekerkaya'],
		abstract:
			'This book share the valuable ideas of esteemed marketing scholars and experts on the latest and most-valued concepts and developments in different sectors, particularly concerning the competitive marketing landscape in different markets around the world.',
		publication_date: '2020',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/36.7FF3C90DEEA946DC8C87E75B309D73C5.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management', 'Marketing'],
	},
	{
		title: 'Digital Accessibility as a Business Practice',
		authors: ['Digital Education Strategies', 'The Chang School'],
		abstract:
			'Most business leaders would agree that reaching the broadest audience is good for a business’s bottom line. A good portion of that audience will be people with disabilities. This book answers how an organization can ensure it is as accessible as it can be to clients and customers, and provides strategies and resources to make digital accessibility a part of an organization’s business culture.',
		publication_date: '2019',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/37.Digital-Accessibility-as-a-Business-Practice-1571157632.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management'],
	},
	{
		title: 'Electronic Commerce: The Strategic Perspective',
		authors: [
			'Richard T. Watson',
			'Pierre Berthon',
			'Leyland F. Pitt',
			'George M. Zinkhan',
		],
		abstract:
			'This book is written both for practitioners and business students. Managers wishing to understand how electronic commerce is revolutionizing business will find comprehensive coverage of essential business issues (e.g., pricing and distribution). Advanced business students will find the blend of academic structure and practical examples engaging.',
		publication_date: '2014',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/38.Electronic-Commerce-The-Strategic-Perspective-1653439969.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Economics',
			'Finance',
			'Business Management',
			'Electronic commerce',
		],
	},
	{
		title: 'Estado abierto y gestión pública: el papel del sector académico',
		authors: ['Comisión Económica para América Latina y el Caribe - CEPAL'],
		abstract:
			'En este libro se aborda el papel del sector académico en relación con el paradigma de Estado abierto inclusivo y su gestión pública, en el marco de la Agenda 2030 para el Desarrollo Sostenible, la apertura, la innovación, las nuevas formas de participación y colaboración del sector y sus proyecciones en el marco de la denominada “era exponencial”, en que los cambios en el tiempo se producen con una creciente aceleración.',
		publication_date: '2023',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/39.S2300544_es.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management', 'Public finance'],
	},
	{
		title:
			'Global Corruption: Its Regulation under International Conventions, US, UK, and Canadian Law and Practice - 4th Edition',
		authors: ['Gerry Ferguson'],
		abstract:
			'This book was created to make it easier for professors to offer a law school course on global corruption and serves as a resource tool for anti-corruption work. It covers the nature and extent of corruption and sets out international standards and requirements to combat corruption, including the UN Convention Against Corruption (UNCAC) and the OECD Bribery of Foreign Officials Convention (OECD Convention).',
		publication_date: '2022',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/40.OTB_187_02_Global_Corruption_4th_Edition_d5ab40cb1b.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Business management', 'Corruption'],
	},
];

const data_MIAMINSTITUTE = [
	{
		title: 'A challenge for the author',
		authors: ['Uta Hagen'],
		abstract:
			'A Challenge for the Actor” by Uta Hagen is a fundamental work for actors looking to deepen their craft. Through her personal experiences and teachings, Hagen provides a practical and profound approach to the acting process. The book emphasizes the importance of self-awareness, emotional connection, and total commitment to the character. With a clear focus on authenticity and emotional truth, Hagen challenges actors to push beyond conventional techniques, striving for a more complete and resonant performance',
		publication_date: '1991',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/A_Challenge_for_the_actor.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'challenge',
			'author',
			'acting',
			'act',
			'actor',
			'uta',
			'hagen',
			'performance',
			'authenticity',
			'emotional truth',
			'self-awareness',
			'character',
			'acting techniques',
			'art of acting',
			'performance challenge',
			'commitment',
			"actor's craft",
			'theatre',
			'method acting',
		],
	},
	{
		title: 'A Dream of Passion',
		authors: ['Lee Strasberg'],
		abstract:
			"In this foundational text, Lee Strasberg—the legendary father of Method Acting—details the development and principles of his revolutionary technique. He traces its roots from the Stanislavski System and provides essential exercises for the actor's training.",
		publication_date: '1987',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/A_Dream_of_Passion.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'dream',
			'passion',
			'acting',
			'actor',
			'lee',
			'strasberg',
			'method',
			'acting',
			'stanislavski',
			'performance',
			'emotional preparation',
			'psychological realism',
			'authenticity',
			'character development',
			'acting techniques',
			'theatre',
			'training',
			'stage',
			'art',
		],
	},
	{
		title: 'The Power of the Actor',
		authors: ['Ivana Chubbuck'],
		abstract:
			'A groundbreaking step-by-step guide to the Chubbuck Technique, a revolutionary approach to acting that teaches performers how to use their personal experiences and emotions to create powerful, authentic characters. This method combines psychological motivation with practical acting tools to achieve compelling performances.',
		publication_date: '2004',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_Power_of_the_Actor_Revised_and_Updated.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'power',
			'acting',
			'actor',
			'act',
			'ivana',
			'chubbuck',
			'chubbuck Technique',
			'character',
			'emotional preparation',
			'psychological realism',
			'script analysis',
			'performance',
			'scene work',
			'hollywood',
			'theatre',
			'audition',
			'personalization',
			'objective',
			'obstacle',
		],
	},
	{
		title: "The Filmmaker's Eye",
		authors: ['Gustavo Mercado'],
		abstract:
			'A comprehensive guide to the language of cinema, this book explores the fundamental principles of shot composition, lighting, and camera techniques. It provides filmmakers with essential tools to create visually compelling and emotionally resonant storytelling through masterful use of cinematic language and visual design.',
		publication_date: '2019',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_Filmmakers_Eye.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'filmmakers',
			'eye',
			'gustavo',
			'mercado',
			'filmmaking',
			'cinematography',
			'shot composition',
			'camera techniques',
			'visual storytelling',
			'lighting',
			'film direction',
			'cinematic language',
			'frame composition',
			'visual design',
			'film production',
			'camera angles',
			'lens selection',
			'movement',
			'color theory',
			'visual narrative',
			'film aesthetics',
			'directing',
		],
	},
	{
		title: 'The Color Correction Handbook',
		authors: ['Alexis Van Hurkman'],
		abstract:
			'A comprehensive professional guide to color grading and correction techniques for film, video, and digital media. This handbook covers fundamental principles, advanced workflows, and practical techniques for achieving cinematic looks, managing consistency across shots, and mastering the art of color storytelling.',
		publication_date: '2014',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_Color_Correction_Handbook.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'color',
			'correction',
			'handbook',
			'alexis',
			'van',
			'hurkman',
			'color grading',
			'color correction',
			'color theory',
			'color timing',
			'davinci resolve',
			'color science',
			'cinematic looks',
			'color workflow',
			'video editing',
			'post production',
			'color matching',
			'primary correction',
			'secondary correction',
			'scopes',
			'waveform',
			'vectorscope',
			'color management',
			'LUTs',
			'lookup tables',
		],
	},
	{
		title: 'The Complete Guide to Film and Digital Production',
		authors: ['Lorene Wales'],
		abstract:
			'A comprehensive guide to the entire filmmaking process, covering all aspects of production from development and pre-production through post-production and distribution. This resource details the roles of crew members, production workflows, budgeting, and the integration of digital technologies in modern filmmaking.',
		publication_date: '2017',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_complete_Guide_to_digital_film_production.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'complete',
			'guide',
			'film',
			'digital',
			'production',
			'lorene',
			'wales',
			'filmmaking',
			'film production',
			'digital production',
			'pre-production',
			'post-production',
			'film budgeting',
			'production workflow',
			'film crew',
			'production roles',
			'film distribution',
			'production management',
			'film industry',
			'production process',
			'digital workflow',
			'film development',
			'production logistics',
		],
	},
	{
		title: 'Respect for Acting',
		authors: ['Uta Hagen'],
		abstract:
			"A foundational text in actor training that presents a practical approach to the craft of acting. The book outlines essential techniques for developing believable characters, including exercises for emotional recall, physical action, and moment-to-moment truth on stage. It emphasizes the actor's dedication to authenticity and psychological realism in performance.",
		publication_date: '1973',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Respect_for_acting.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'respect',
			'acting',
			'uta',
			'hagen',
			'acting',
			'actor training',
			'character development',
			'emotional recall',
			'physical action',
			'stagecraft',
			'theatre',
			'acting techniques',
			'psychological realism',
			'authenticity',
			'moment-to-moment',
			'acting exercises',
			'performance',
			'acting theory',
			'drama',
			'theater',
			'actor preparation',
			'scene work',
			'object exercises',
		],
	},
	{
		title: 'An Actor Prepares',
		authors: ['Konstantin Stanislavski'],
		abstract:
			"The foundational text of modern acting theory, this book presents Stanislavski's revolutionary system through the narrative of a young actor's training. It introduces core concepts such as emotional memory, the magic if, given circumstances, and objectives that transformed acting into a psychological and disciplined art form.",
		publication_date: '1936',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/An+Actor+Prepares.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'actor',
			'prepares',
			'konstantin',
			'stanislavski',
			'acting',
			'act',
			'method acting',
			'emotional memory',
			'the magic if',
			'given circumstances',
			'objectives',
			'super objective',
			'through line',
			'psychological realism',
			'actor training',
			'theatre',
			'drama',
			'character development',
			'stagecraft',
			'performance technique',
			'internal acting',
			'emotional recall',
			'concentration',
			'imagination',
		],
	},
	{
		title: 'Building a Character',
		authors: ['Konstantin Stanislavski'],
		abstract:
			"The second book in Stanislavski's seminal acting trilogy, focusing on the external aspects of character creation. This work explores physical transformation, voice, speech, movement, and the development of a character's external traits while maintaining psychological truth. It provides practical exercises for actors to master the physical embodiment of their roles.",
		publication_date: '1950',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Building-A-Character.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'building',
			'character',
			'konstantin',
			'stanislavski',
			'acting',
			'character development',
			'physical transformation',
			'voice training',
			'speech',
			'movement',
			'external technique',
			'characterization',
			'body language',
			'physical acting',
			'stage presence',
			'actor training',
			'stanislavski system',
			'theatre',
			'drama',
			'performance',
			'embodiment',
			'gesture',
			'posture',
			'vocal projection',
			'physical expression',
		],
	},
	{
		title: 'Creating a Role',
		authors: ['Konstantin Stanislavski'],
		abstract:
			"The third volume in Stanislavski's groundbreaking trilogy, this book focuses on the practical application of his system to specific roles and plays. It guides actors through the complete process of role development, from initial script analysis and research to rehearsal techniques and final performance, using detailed examples from classic plays.",
		publication_date: '1961',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Creating+a+role.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'creating',
			'role',
			'konstantin',
			'stanislavski',
			'acting',
			'script analysis',
			'character development',
			'rehearsal techniques',
			'role preparation',
			'stanislavski system',
			'play analysis',
			'actor preparation',
			'theatre',
			'drama',
			'performance',
			'character research',
			'subtext',
			'given circumstances',
			'objectives',
			'super objective',
			'emotional preparation',
			'scene work',
			'acting process',
			'theatrical interpretation',
		],
	},
	{
		title: 'Audition',
		authors: ['Michael Shurtleff'],
		abstract:
			'The definitive guide to auditioning for actors, presenting the famous 12 guideposts for script analysis and performance. This book teaches actors how to make strong choices, build relationships on stage, and stand out in auditions through practical techniques for scene analysis, character development, and emotional connection.',
		publication_date: '1978',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/audition-by-michael-shurtleff.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'audition',
			'michael',
			'shurtleff',
			'acting',
			'auditioning',
			'12 guideposts',
			'script analysis',
			'casting',
			'actor',
			'audition techniques',
			'scene study',
			'character choices',
			'relationship',
			'conflict',
			'humor',
			'opposites',
			'discoveries',
			'communication',
			'competition',
			'importance',
			'theatre',
			'film',
			'television',
			'casting director',
			'performance',
		],
	},
	{
		title: 'The Science and Art of Acting for the Camera',
		authors: ['John Howard Swain'],
		abstract:
			'A comprehensive guide that bridges the gap between stage acting and camera performance, exploring both the artistic and technical aspects of acting for film and television. The book provides practical techniques for adapting acting skills to the camera, covering emotional truth, technical requirements, and the specific demands of on-camera work.',
		publication_date: '2017',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_Science_and_Art_of_Acting_for_the_Camera.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'science',
			'art',
			'acting',
			'camera',
			'john',
			'howard',
			'swain',
			'acting',
			'camera acting',
			'film acting',
			'television acting',
			'on-camera technique',
			'emotional truth',
			'technical acting',
			'screen performance',
			'film set',
			'camera awareness',
			'subtlety',
			'continuity',
			'frame',
			'lens',
			'close-up',
			'film production',
			'audition techniques',
			'character development',
		],
	},
	{
		title: 'Cinematography: Theory and Practice',
		authors: ['Blain Brown'],
		abstract:
			'A comprehensive guide to both the artistic and technical aspects of cinematography, covering everything from fundamental camera operations to advanced lighting techniques and visual storytelling. This book explores how cinematographers use lighting, composition, camera movement, and color to create mood, meaning, and narrative impact in film and video.',
		publication_date: '2016',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Cinematography_theory_and_practice.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'cinematography',
			'theory',
			'practice',
			'blain',
			'brown',
			'cinematography',
			'lighting',
			'camera',
			'composition',
			'visual storytelling',
			'film production',
			'camera movement',
			'color theory',
			'exposure',
			'lenses',
			'camera angles',
			'shot composition',
			'digital cinema',
			'film techniques',
			'visual design',
			'depth of field',
			'framing',
			'camera operators',
			'director of photography',
			'DP',
			'film lighting',
			'image making',
		],
	},
	{
		title: 'Film Directing Shot by Shot',
		authors: ['Steven D. Katz'],
		abstract:
			'A visual guide to filmmaking that explores the language of cinema through storyboards, shot composition, and visual storytelling techniques. This book provides practical tools for directors to plan and visualize their films, covering continuity, camera angles, blocking, and the relationship between visual design and narrative structure.',
		publication_date: '1991',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Film_Directing_Shot_by_Shot.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'film',
			'directing',
			'shot',
			'shot',
			'steven',
			'katz',
			'film directing',
			'shot composition',
			'storyboarding',
			'visual storytelling',
			'camera angles',
			'continuity',
			'blocking',
			'scene planning',
			'visual design',
			'film language',
			'directing techniques',
			'pre-production',
			'storyboard',
			'frame',
			'cinematic space',
			'camera movement',
			'visual narrative',
			'film planning',
			'director',
			'shot list',
		],
	},
	{
		title: 'In the Blink of an Eye',
		authors: ['Walter Murch'],
		abstract:
			'A seminal work on film editing that explores the philosophical, psychological, and practical aspects of editing. Walter Murch presents his revolutionary ideas about how editing relates to human perception, including his famous "Rule of Six" and insights on why cuts work, blink timing, and the emotional rhythm of film.',
		publication_date: '1995',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/In_the_Blink_of_an_Eye.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'blink',
			'eye',
			'walter',
			'murch',
			'film editing',
			'editing',
			'film theory',
			'editing techniques',
			'rule of six',
			'film rhythm',
			'emotional rhythm',
			'continuity editing',
			'film perception',
			'editing philosophy',
			'film psychology',
			'cutting',
			'transition',
			'timing',
			'blink',
			'film structure',
			'narrative flow',
			'post-production',
			'film making',
			'editor',
		],
	},
	{
		title: 'Grammar of the Film Language',
		authors: ['Daniel Arijon'],
		abstract:
			'A comprehensive visual guide to the fundamental principles of film language and visual storytelling. This classic work systematically explores shot composition, camera angles, editing techniques, and visual continuity, serving as an essential reference for filmmakers seeking to master the visual vocabulary of cinema.',
		publication_date: '1976',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Grammar_of_the_film_language.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'grammar',
			'film',
			'language',
			'daniel',
			'arijon',
			'film language',
			'visual storytelling',
			'shot composition',
			'camera angles',
			'editing',
			'continuity',
			'visual grammar',
			'film techniques',
			'cinematic syntax',
			'framing',
			'camera movement',
			'scene transition',
			'visual narrative',
			'film direction',
			'cinematography',
			'storytelling',
			'film syntax',
			'visual continuity',
			'film making',
			'directing',
		],
	},
	{
		title: 'Directing the Documentary',
		authors: ['Michael Rabiger'],
		abstract:
			'A comprehensive guide to the art and craft of documentary filmmaking, covering all stages from concept development to distribution. This book provides practical techniques for research, interviewing, shooting in real-world conditions, ethical considerations, and shaping raw footage into compelling narrative stories that reflect truth and perspective.',
		publication_date: '2015',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Directing-the-Documentary.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'directing',
			'documentary',
			'michael',
			'rabiger',
			'documentary',
			'filmmaking',
			'documentary directing',
			'non-fiction',
			'interview techniques',
			'ethical filmmaking',
			'documentary research',
			'real-world shooting',
			'story structure',
			'documentary editing',
			'cinema verite',
			'observational cinema',
			'documentary ethics',
			'fundraising',
			'distribution',
			'post-production',
			'character development',
			'truth in storytelling',
			'documentary narrative',
			'film proposal',
		],
	},
	{
		title: "The Filmmaker's Handbook",
		authors: ['Steven Ascher', 'Edward Pincus'],
		abstract:
			'A comprehensive guide to the entire filmmaking process, from development and pre-production to distribution. This authoritative volume covers techniques for dramatic, documentary, corporate, and experimental projects, providing practical advice on shooting, lighting, sound recording, editing, and the business aspects of producing and funding a film.',
		publication_date: '2013',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The-Filmmakers-Handbook.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'filmmakers',
			'handbook',
			'steven',
			'ascher',
			'edward',
			'pincus',
			'filmmaking',
			'film production',
			'digital video',
			'cinematography',
			'lighting',
			'sound recording',
			'video editing',
			'post-production',
			'film distribution',
			'pre-production',
			'documentary',
			'DSLR',
			'film budgeting',
			'film directing',
		],
	},
	{
		title: 'Film Production Management',
		authors: ['Bastian Clevé'],
		abstract:
			'A comprehensive guide to film production management focusing on the entire production process from development to delivery. This third edition covers contemporary practices in budgeting, scheduling, legal requirements, and international co-productions, providing essential knowledge for producers and production managers in the global film industry.',
		publication_date: '2006',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Film_Production_Management.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'film',
			'production',
			'management',
			'bastian',
			'clevé',
			'production management',
			'film budgeting',
			'production scheduling',
			'international co-productions',
			'film financing',
			'production law',
			'contracts',
			'rights clearance',
			'film insurance',
			'production planning',
			'shoot management',
			'post-production supervision',
			'film delivery',
			'producer',
			'line producer',
			'film industry',
			'global production',
		],
	},
	{
		title: 'Acting in Film',
		authors: ['Michael Caine'],
		abstract:
			'An essential guide to film acting by acclaimed actor Michael Caine, offering practical advice and techniques for performing in front of the camera. The book covers everything from hitting marks and working with close-ups to maintaining consistency across takes and collaborating with directors and crew.',
		publication_date: '1990',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Acting_in_Film.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'acting',
			'film',
			'michael',
			'caine',
			'film acting',
			'camera technique',
			'close-up',
			'hitting marks',
			'continuity',
			'film set',
			'actor preparation',
			'screen performance',
			'film crew',
			'directing actors',
			'rehearsal',
			'take',
			'performance',
			'subtlety',
			'film industry',
			'movie making',
			'acting tips',
			'professional acting',
		],
	},
	{
		title: 'The Business of Film',
		authors: ['Lawrence Turman', 'Stephen Fell'],
		abstract:
			'A comprehensive guide to the business and financial aspects of the film industry, covering the entire lifecycle of a film project from development and financing to distribution and marketing. This book provides practical insights into producing, deal-making, contracts, and the economic realities of getting films made and seen by audiences.',
		publication_date: '2019',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_business_of_film.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'business',
			'film',
			'lawrence',
			'turman',
			'stephen',
			'fell',
			'film business',
			'film financing',
			'film distribution',
			'producing',
			'deal-making',
			'film contracts',
			'entertainment law',
			'film marketing',
			'box office',
			'film economics',
			'production financing',
			'distribution deals',
			'film sales',
			'rights management',
			'film industry',
			'movie business',
			'financial planning',
			'revenue streams',
			'film investment',
		],
	},
	{
		title: 'Producer to Producer',
		authors: ['Maureen A. Ryan'],
		abstract:
			'A comprehensive step-by-step guide to independent film producing that takes filmmakers through the entire production process from concept to distribution. The book provides practical tools, templates, and real-world advice on budgeting, scheduling, fundraising, crew management, and navigating the business aspects of independent filmmaking.',
		publication_date: '2017',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Producer_to_Producer.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'producer',
			'producer',
			'maureen',
			'ryan',
			'film producing',
			'independent film',
			'film budgeting',
			'production scheduling',
			'fundraising',
			'film financing',
			'crowdfunding',
			'production management',
			'film business',
			'independent producing',
			'film distribution',
			'production templates',
			'crew management',
			'film contracts',
			'pre-production',
			'post-production',
			'film festival',
			'low-budget filmmaking',
			'production forms',
		],
	},
	{
		title: 'So You Want to Be a Producer',
		authors: ['Lawrence Turman'],
		abstract:
			'A practical guide to film producing from veteran producer Lawrence Turman, offering insider knowledge and career advice for aspiring producers. The book covers the creative, business, and leadership aspects of producing, including project selection, talent management, financing strategies, and the day-to-day realities of shepherding a film from idea to screen.',
		publication_date: '2005',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/So_You_Want_to_Be_a_Producer.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'you',
			'want',
			'to be',
			'producer',
			'lawrence',
			'turman',
			'film producing',
			'producer',
			'career guide',
			'film career',
			'project development',
			'talent management',
			'film financing',
			'creative producing',
			'leadership',
			'film industry',
			'movie business',
			'producer role',
			'career advice',
			'entertainment industry',
			'film development',
			'packageing',
			'deal making',
			'hollywood',
		],
	},
];

const data_LAURELI = [
	{
		title: 'Application of Plant-Based Molecules and Materials in Cosmetics',
		authors: ['Paulraj Mosae Mosae Selvakumar'],
		abstract:
			'With the growing demand for products that are gentle on the skin and manufactured by eco-friendly means, the field of cosmetics is witnessing a remarkable shift toward natural ingredients',
		publication_date: '2024',
		url: 'https://www.mdpi.com/2079-9284/11/6/211',
		type: '',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Application',
			'Plant-Based',
			'Molecules',
			'Materials',
			'Cosmetics',
			'Paulraj',
			'Mosae',
			'Selvakumar',
			'growing',
			'demand',
			'natural',
			'ingredients',
			'eco-friendly',
			'skin',
			'cosmetic-products',
			'plant-derived',
			'bioactive-compounds',
			'sustainability',
			'green-chemistry',
			'formulations',
			'botanical-extracts',
			'phytochemicals',
			'beauty-products',
			'personal-care',
			'natural-cosmetics',
			'clean-beauty',
			'biomaterials',
			'skin-care',
			'environmentally-friendly',
		],
	},
	{
		title: 'BAM Chapter 23: Methods for Cosmetics',
		authors: [
			'Jo Huang, Anthony D. Hitchins ',
			'Tony T. Tran',
			'James E. McCarron',
		],
		abstract:
			"FDA's Bacteriological Analytical Manual (BAM) presents the agency's preferred laboratory procedures for microbiological analyses of foods and cosmetics.",
		publication_date: '2025',
		url: 'https://www.fda.gov/food/laboratory-methods-food/bam-chapter-23-methods-cosmetics',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'BAM',
			'Chapter',
			'Methods',
			'Cosmetics',
			'Jo',
			'Huang',
			'Anthony',
			'Hitchins',
			'Tony',
			'Tran',
			'James',
			'McCarron',
			'FDA',
			'Bacteriological',
			'Analytical',
			'Manual',
			'laboratory',
			'procedures',
			'microbiological',
			'analyses',
			'foods',
			'cosmetics-testing',
			'microbiology',
			'laboratory-methods',
			'regulatory',
			'quality-control',
			'safety-testing',
			'contamination',
			'microbial-analysis',
			'standard-procedures',
			'food-safety',
			'cosmetic-safety',
		],
	},
	{
		title: 'Barbering Techniques for Hairstylists',
		authors: ['Arden Magtiza and Gary Franceschini'],
		abstract:
			'This manual serves as a guide for apprentices who desire to grow beyond their foundational haircutting knowledge and skills, and expand their knowledge to include more advanced barbering services, such as beard and moustache design, and straight razor shaves.',
		publication_date: '2021',
		url: 'https://collection.bccampus.ca/textbook/cte79aLm/',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Barbering',
			'Techniques',
			'Hairstylists',
			'Arden',
			'Magtiza',
			'Gary',
			'Franceschini',
			'manual',
			'apprentices',
			'haircutting',
			'skills',
			'advanced',
			'barbering-services',
			'beard-design',
			'moustache-design',
			'razor-shaves',
			'grooming',
			'hair-design',
			'barber-tools',
			'styling',
		],
	},
	{
		title: 'Cosmetics Labeling Guide',
		authors: ['Office of the Commissioner'],
		abstract:
			'The Cosmetics Labeling Guide provides step-by-step help with cosmetic labeling, with examples and answers to questions  manufacturers often ask about labeling requirements under U.S. laws and related regulations.',
		publication_date: '2021',
		url: 'https://www.fda.gov/cosmetics/cosmetics-labeling-regulations/cosmetics-labeling-guide',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Cosmetics',
			'Labeling',
			'Guide',
			'Office',
			'Commissioner',
			'FDA',
			'labeling-requirements',
			'regulations',
			'U.S.-laws',
			'cosmetic-products',
			'manufacturers',
			'compliance',
			'packaging',
			'claims',
			'ingredient-listing',
			'labeling-rules',
			'guidelines',
			'examples',
			'instructions',
			'regulatory',
		],
	},
	{
		title: 'Evidence-Based Massage Therapy: A Guide for Clinical Practice',
		authors: ['Richard Lebert'],
		abstract:
			'This clinical practice handbook will prove essential to massage therapists, physical therapists, chiropractors, medical doctors, psychologists and other health professionals who care for people with musculoskeletal pain. It is a living document and will be continuously updated as new research becomes available.',
		publication_date: '2018',
		url: 'https://collection.bccampus.ca/textbook/7WiDhceU/',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Evidence-Based',
			'Massage',
			'Therapy',
			'Clinical',
			'Practice',
			'Richard',
			'Lebert',
			'handbook',
			'therapists',
			'physical-therapy',
			'chiropractic',
			'health-professionals',
			'musculoskeletal-pain',
			'treatment',
			'manual-therapy',
			'rehabilitation',
			'pain-management',
			'clinical-guidelines',
			'research',
			'healthcare',
		],
	},
	{
		title: 'Hair Colour for Hairstylists: Level 2',
		authors: ['Arden Magtiza'],
		abstract:
			'This manual serves as a guide for apprentices with the desire to stretch beyond their foundational colour knowledge and skills so as to reach a higher level of competency. This text will walk the stylist step-by-step through many current and advanced techniques used in the industry today.',
		publication_date: '2021',
		url: 'https://collection.bccampus.ca/textbooks/hair-colour-for-hairstylists-level-2-bccampus-147/',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Hair',
			'Colour',
			'Hairstylists',
			'Level-2',
			'Arden',
			'Magtiza',
			'manual',
			'apprentices',
			'colour-knowledge',
			'skills',
			'competency',
			'stylist',
			'techniques',
			'advanced',
			'industry',
			'hair-colouring',
			'formulation',
			'application',
			'professional',
			'training',
		],
	},
	{
		title: 'Introductory Chemistry - 1st Canadian Edition',
		authors: ['Jessie A. Key', 'David W. Ball'],
		abstract:
			'The goal of this textbook is not to make you an expert. True expertise in any field is a years-long endeavor. Here I will survey some of the basic topics of chemistry. This survey should give you enough knowledge to appreciate the impact of chemistry in everyday life and, if necessary, prepare you for additional instruction in chemistry.Throughout each chapter, I present two features that reinforce the theme of the textbook.',
		publication_date: '2014',
		url: 'https://collection.bccampus.ca/textbook/8zgWk4FT/',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Introductory',
			'Chemistry',
			'Canadian',
			'Edition',
			'Jessie',
			'Key',
			'David',
			'Ball',
			'textbook',
			'basic-topics',
			'chemical-principles',
			'everyday-life',
			'foundations',
			'survey',
			'instruction',
			'chapters',
			'science',
			'learning',
			'education',
			'fundamentals',
		],
	},
	{
		title:
			'The Case for Pain Relief: 5 Research Studies for Massage Therapists',
		authors: ['Massage Theraphy Foundation'],
		abstract:
			"Likely highlights massage's benefits, showing it reduces pain, anxiety, depression, and improves strength in conditions like low back pain, cancer pain, and carpal tunnel, using evidence from studies by Field and others, indicating even short sessions with moderate pressure yield significant results, though high-certainty evidence for superiority over other active treatments is often lacking, necessitating more rigorous trials. ",
		publication_date: '2012',
		url: 'https://massagetherapyfoundation.org/wp-content/uploads/mtf-pain-relief-ebook.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Pain',
			'Relief',
			'Massage',
			'Therapists',
			'Massage-Therapy-Foundation',
			'research',
			'studies',
			'pain-reduction',
			'anxiety',
			'depression',
			'strength',
			'low-back-pain',
			'cancer-pain',
			'carpal-tunnel',
			'moderate-pressure',
			'treatment-effects',
			'evidence',
			'clinical',
			'outcomes',
			'therapeutic-benefits',
		],
	},
	{
		title:
			'5 Myths and Truths about Massage Therapy: Letting Go Without Losing Heart',
		authors: ['Massage Theraphy Foundation'],
		abstract:
			"Likely details common misconceptions (like massage detoxifies or is always painful) versus realities (it promotes well-being, enhances immune function, improves circulation locally, and addresses chronic pain patterns). The core idea is debunking myths to focus on proven benefits like stress reduction, pain relief, increased mobility, and supporting the body's healing, emphasizing the need for honest, evidence-based communication in the massage field. ",
		publication_date: '2016',
		url: 'https://www.tracywalton.com/wp-content/uploads/2016/09/5-Myths-and-Truths-about-Massage-Therapy_final-with-Page-Numers.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Myths',
			'Truths',
			'Massage',
			'Therapy',
			'Massage-Therapy-Foundation',
			'misconceptions',
			'evidence-based',
			'well-being',
			'immune-function',
			'circulation',
			'chronic-pain',
			'stress-reduction',
			'pain-relief',
			'mobility',
			'healing',
			'benefits',
			'education',
			'communication',
			'health',
			'therapeutic',
		],
	},
];

const DENTISTRY_BOOKS = [
	{
		title: 'Modern Dental Assisting',
		authors: ['Doni Bird', 'Robinson Debbie'],
		abstract:
			'This book provide the background, principles, and techniques necessary to become an educationally qualified and competent dental assistant.',
		publication_date: '2015',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Modern_dental_assistant_-_Debbie_S_Robinson.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Dentistry',
			'Health Education',
			'Medical personnel',
			'Modern dental',
			'modern dental assisting',
			'dentist',
			'dental',
		],
	},
];
